const doc = [({"en":({"js":({"admin":({"tenants":({"setup":({"the_settings_were_saved":"The settings were saved"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;